import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=0d3ddac4&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"
import style0 from "./page3.vue?vue&type=style&index=0&id=0d3ddac4&lang=scss&scoped=true&"
import style1 from "./page3.vue?vue&type=style&index=1&id=0d3ddac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ddac4",
  null
  
)

export default component.exports